
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.35 11.457h.629v.641c0 .825.4 1.187 1.193 1.187h6.335c.794 0 1.194-.362 1.194-1.187v-.641h.628c1.187 0 1.822-.61 1.822-1.796V4.075c0-1.187-.635-1.797-1.822-1.797h-.578v-.323c0-1.187-.59-1.72-1.726-1.72h-5.37c-1.08 0-1.727.533-1.727 1.72v.323h-.577c-1.13 0-1.822.61-1.822 1.797V9.66c0 1.187.635 1.796 1.822 1.796zm1.568-9.572c0-.489.248-.73.73-.73h5.383c.483 0 .73.241.73.73v.393H3.918v-.393zm-1.574 8.607c-.52 0-.787-.273-.787-.787V4.03c0-.52.267-.793.787-.793h9.991c.521 0 .788.273.788.793v5.675c0 .514-.267.787-.788.787h-.634v-3.53c0-.824-.4-1.186-1.194-1.186H4.172c-.755 0-1.193.362-1.193 1.187v3.53h-.635zm2.108 1.847c-.305 0-.464-.152-.464-.47V7.186c0-.311.159-.457.464-.457h5.776c.311 0 .463.146.463.457v4.685c0 .317-.152.47-.463.47H4.452zm.844-3.465h4.1a.369.369 0 00.375-.381.36.36 0 00-.375-.362h-4.1c-.222 0-.381.159-.381.362 0 .216.159.38.38.38zm0 2.082h4.1a.36.36 0 00.375-.362.369.369 0 00-.375-.381h-4.1a.37.37 0 00-.381.38c0 .204.159.363.38.363z","fill":"#000"}})])
          )
        }
      }
    